import { call } from 'redux-saga/effects';

import createWorker from 'app/redux/utils/create-worker';
import workInterval from 'app/redux/utils/work-interval';

import constants from 'app/constants/cache';

import questionsAPI from 'app/api/questions';

const execute = function*() {
  return yield call(questionsAPI.getQuestionsCategoryOptions);
};

export const {
  Actions,
  Generators,
  ReducerHandlers,
  Saga,
  Types,
  initState,
  localStateSelector,
  Selectors,
} = createWorker('questions/category-options', {
  localStateSelector: 'questionsCategoryOptions',
  execute,
  shouldWork: workInterval(constants.defaultUpdateIntervalInMilliseconds),
  takePolicy: 'latest',
});



// WEBPACK FOOTER //
// ./src/redux/questions/category-options/workers.js